// extracted by mini-css-extract-plugin
export default {"form":"RequestIntegration-module__form--XJgwA","submit":"RequestIntegration-module__submit--WATJ5"};